import React, { useMemo, useState } from "react";
import { Row, Col, Form, Spinner } from "react-bootstrap";
import { Link } from "react-router-dom";
import DeleteModal, { ModalAdd } from "Components/DeleteModal";
import {
  useDeleteStoreAddressMutation,
  useGetStoreMyAddressesQuery,
  useSetDefaultStoreAddressMutation,
} from "../../redux/services/store/storeAccountApi";

export const ShopingAddress = ({ title, HomeAdd, officeAdd, from }: any) => {
  const { data, isLoading, isFetching, isError } = useGetStoreMyAddressesQuery();
  const [deleteStoreAddress] = useDeleteStoreAddressMutation();
  const [setDefaultStoreAddress] = useSetDefaultStoreAddressMutation();

  const [removeModel, setRemovemodel] = useState(false);
  const [selectedId, setSelectedId] = useState<number | null>(null);
  const [addressModal, setAddressModal] = useState(false);
  const [editAddress, setEditAddress] = useState<any>(null);

  const isBillingSection = String(title || "").toLowerCase().includes("billing");
  const radioName = isBillingSection ? "billingAddress" : "shippingAddress";
  const openInlineModal = String(from || "").toLowerCase() === "checkout";
  const defaultAddressType = isBillingSection ? "billing" : "shipping";

  const addresses = useMemo(() => {
    const rows = Array.isArray(data) ? data : [];
    return rows.filter((item: any) => !!item?.is_active);
  }, [data]);

  const selectedAddressId = useMemo(() => {
    const selected = addresses.find((item: any) =>
      isBillingSection ? item?.is_default_billing : item?.is_default_shipping
    );
    return selected?.id ?? null;
  }, [addresses, isBillingSection]);

  const RemoveModel = (id?: number | null) => {
    if (id !== undefined && id !== null) {
      setSelectedId(id);
      setRemovemodel(true);
      return;
    }
    setRemovemodel(false);
  };

  const handleCloseAddressModal = () => {
    setAddressModal(false);
    setEditAddress(null);
  };

  const handleShowAdd = () => {
    setEditAddress(null);
    setAddressModal(true);
  };

  const handleShowEdit = (address: any) => {
    setEditAddress(address);
    setAddressModal(true);
  };

  const deleteData = async () => {
    if (!selectedId) return;
    try {
      await deleteStoreAddress(selectedId).unwrap();
      setRemovemodel(false);
      setSelectedId(null);
    } catch (e) {
      console.log(e);
    }
  };

  const handleSelectDefault = async (addressId: number) => {
    try {
      await setDefaultStoreAddress({
        address_id: addressId,
        kind: isBillingSection ? "billing" : "shipping",
      }).unwrap();
    } catch (e) {
      console.log(e);
    }
  };

  const getAddressBadge = (item: any) => {
    if (item?.label) return item.label;
    if (item?.address_type === "billing") return officeAdd || "Billing Address";
    if (item?.address_type === "shipping") return HomeAdd || "Shipping Address";
    return item?.address_type || "";
  };

  const getAddressLine = (item: any) => {
    return [item?.line1, item?.line2, item?.landmark, item?.city, item?.state, item?.postal_code]
      .filter(Boolean)
      .join(", ");
  };

  return (
    <React.Fragment>
      <div className="mt-4 pt-2">
        <div className="d-flex align-items-center mb-4">
          <div className="flex-grow-1">
            <h5 className="mb-0">{title || ""}</h5>
          </div>
          <div className="flex-shrink-0">
            {openInlineModal ? (
              <Link
                to="#"
                className="badge bg-secondary-subtle text-secondary link-secondary"
                onClick={(e) => {
                  e.preventDefault();
                  handleShowAdd();
                }}
              >
                Add Address
              </Link>
            ) : (
              <Link
                to="/shop/address"
                state={{ from }}
                className="badge bg-secondary-subtle text-secondary link-secondary"
              >
                Add Address
              </Link>
            )}
          </div>
        </div>

        <Row className="gy-3">
          {isError ? (
            <Col xs={12}>
              <div className="text-danger">Failed to load addresses</div>
            </Col>
          ) : isLoading || isFetching ? (
            <Col xs={12}>
              <div className="text-center py-3">
                <Spinner animation="border" size="sm" /> Loading...
              </div>
            </Col>
          ) : addresses.length === 0 ? (
            <Col xs={12}>
              <div className="text-muted">No address found</div>
            </Col>
          ) : (
            addresses.map((item: any, index: number) => {
              const inputId = `${radioName}-${item.id}-${index}`;
              const checked = selectedAddressId === item.id;

              return (
                <Col lg={6} xs={12} key={item.id}>
                  <div className="form-check card-radio">
                    <Form.Control
                      id={inputId}
                      name={radioName}
                      type="radio"
                      className="form-check-input"
                      checked={checked}
                      onChange={() => handleSelectDefault(item.id)}
                    />
                    <Form.Label className="form-check-label" htmlFor={inputId}>
                      <span className="mb-3 text-uppercase fw-semibold d-block">
                        {getAddressBadge(item)}
                      </span>
                      <span className="fs-14 mb-2 d-block fw-semibold">{item?.contact_name}</span>
                      <span className="text-muted fw-normal text-wrap mb-1 d-block">
                        {getAddressLine(item)}
                      </span>
                      <span className="text-muted fw-normal d-block">
                        Mo. {item?.mobile_e164 || "-"}
                      </span>
                    </Form.Label>
                  </div>

                  <div className="d-flex flex-wrap p-2 py-1 bg-light rounded-bottom border mt-n1">
                    <div>
                      {openInlineModal ? (
                        <Link
                          to="#"
                          className="d-block text-body p-1 px-2"
                          onClick={(e) => {
                            e.preventDefault();
                            handleShowEdit(item);
                          }}
                        >
                          <i className="ri-pencil-fill text-muted align-bottom me-1"></i> Edit
                        </Link>
                      ) : (
                        <Link
                          to="/shop/address"
                          state={{ from }}
                          className="d-block text-body p-1 px-2"
                        >
                          <i className="ri-pencil-fill text-muted align-bottom me-1"></i> Edit
                        </Link>
                      )}
                    </div>
                    <div>
                      <Link
                        to="#removeAddressModal"
                        className="d-block text-body p-1 px-2"
                        data-bs-toggle="modal"
                        onClick={(e) => {
                          e.preventDefault();
                          RemoveModel(item.id);
                        }}
                      >
                        <i className="ri-delete-bin-fill text-muted align-bottom me-1"></i> Remove
                      </Link>
                    </div>
                  </div>
                </Col>
              );
            })
          )}
        </Row>

        <DeleteModal removeModel={removeModel} hideModal={RemoveModel} deleteData={deleteData} />
        <ModalAdd
          addressModal={addressModal}
          handleClose={handleCloseAddressModal}
          editAddress={editAddress}
          defaultAddressType={defaultAddressType}
        />
      </div>
    </React.Fragment>
  );
};
